/**
 * InlineTextView view.
 *
 * @subscribes copy-edit-button-enabled
 * @subscribes copy-edit-button-disabled
 *
 */

var sw = require('./../sw');
var ShapewaysView = require('./ShapewaysView');
var $ = require('./../../sw-jquery/sw-jquery');

window.CKEDITOR_BASEPATH = '/rrstatic/javascript/vendor/ckeditor/';

var scheduledContentEndpoint = '/cms/edit/update-key';

var InlineTextView = ShapewaysView.extend({

  events: {
    'focus': 'onFocus',
    'blur': 'onBlur'
  },

  initialize: function(options) {

    this.token = options.swEditableContentToken;

    this.contentType = options.swEditableContent;
    this.cmsKey      = options.swEditableContentCmsKey;
    this.enterMode   = options.swEditableContentEnterMode;

    this.bindEvents();
  },

  bindEvents: function() {
    this.listenTo(sw, 'copy-edit-button-enabled', this.enableEditing, this);
    this.listenTo(sw, 'copy-edit-button-disabled', this.disableEditing, this);
  },

  enableEditing: function() {
    var self = this;

    require([
      './../../sw-jquery/vendor/sw-ck-adapter',
      'js/vendor/ckeditor/ckeditor'
    ], function(ckPlugin) {
      ckPlugin($);

      self.initCK();
      self.repaint();
    });
  },

  disableEditing: function() {
    this.removeCK();
    this.repaint();
  },

  initCK: function() {

    var config = {};

    if (this.enterMode) {
      if (this.enterMode === 'CKEDITOR.ENTER_P') {
        config.enterMode = window.CKEDITOR.ENTER_P;
      }

      if (this.enterMode === 'CKEDITOR.ENTER_BR') {
        config.enterMode = window.CKEDITOR.ENTER_BR;
      }
    }

    this.editor = this.$el.attr('contenteditable', true).ckeditor(config).editor;
    this.currentContent = this.getContent();
  },

  removeCK: function() {
    this.$el.attr('contenteditable', false);
    this.editor.destroy();
    this.editor = null;
  },

  getContent: function() {
    return this.editor.getData();
  },

  onFocus: function() {
    this.$el.removeClass('sw-inline-text--empty').removeClass('sw-inline-text--saved').removeClass('sw-inline-text--failed');
  },

  onBlur: function() {
    if (!this.editor) {
      return;
    }

    var content = this.getContent();

    if ((content && this.currentContent !== content) || (this.currentContent !== content)) {
      this.postUpdate();
    }

    if (!content) {
      this.$el.addClass('sw-inline-text--empty');
    }
  },

  postUpdate: function() {
    var content = this.getContent();

    var postData = {
      url: scheduledContentEndpoint,
      data: {
        content: content,
        contentType: this.contentType,
        cmsKey: this.cmsKey,
        token: this.token
      },
      type: 'POST',
      dataType: 'json'
    };

    this.$el.addClass('sw-inline-text--updating');

    var self = this;
    $.ajax(postData).done(function(data) {
      self.currentContent = self.getContent();

      if (data.status && data.status === 'ok') {
        self.$el.addClass('sw-inline-text--saved');
      } else {
        self.$el.addClass('sw-inline-text--failed');
      }
    }).complete(function() {
      self.$el.removeClass('sw-inline-text--updating');
    });

  }

});

module.exports = InlineTextView;
